import { useState } from "react";
import { useHMOStore } from "../hooks/use-hmo-store";
import { useFormContext } from "react-hook-form";
import { getNextStepFromIntroForm } from "../utils";
import { FormSchemaType } from "@/features/hmo-consultation/schema";
import { ConsultationType } from "@/features/hmo-consultation/components/consultation-type";
import FormNextButton from "@/features/hmo-consultation/components/form-next-button";
import { EnrolleeIdNoOwnerType } from "./enrollee-id-no-owner-type";

export function IntroFormNoOwnerType() {
  const providerFeatures = useHMOStore((s) => s.providerFeatures);
  const has2FA = providerFeatures?.has2FA;
  const isHospitalConsultation = useHMOStore((s) => s.isHospitalConsultation);
  const hasFollowUpFeature = providerFeatures?.hasFollowUpFeature || false;

  const [foundUser, setFoundUser] = useState(false);

  const canSelectConsultationType =
    hasFollowUpFeature && foundUser && !isHospitalConsultation;

  const { watch, trigger } = useFormContext<FormSchemaType>();
  const isFollowUp = watch("isFollowUp");

  const nextStep = getNextStepFromIntroForm(
    !!isFollowUp,
    !!isHospitalConsultation,
    !!has2FA,
  );

  async function validateStep() {
    if (canSelectConsultationType) {
      return trigger(["hmoId", "isFollowUp"]);
    } else {
      return trigger(["hmoId"]);
    }
  }

  return (
    <form className="flex flex-col gap-4 mt-4">
      {/* HMO ID */}
      {<EnrolleeIdNoOwnerType setFoundUser={setFoundUser} />}

      {foundUser && (
        <div>
          {canSelectConsultationType && <ConsultationType />}

          <FormNextButton
            nextStep={nextStep}
            onClick={validateStep}
            validate={validateStep}
          />
        </div>
      )}
    </form>
  );
}
